import { useEffect, useState } from 'react';
import { fetchPublicNotices, type PublicNoticeSummary } from '../api/notice';

let cached: PublicNoticeSummary[] | null = null;
let inflight: Promise<PublicNoticeSummary[]> | null = null;

function loadNotices(): Promise<PublicNoticeSummary[]> {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = fetchPublicNotices()
      .then((list) => {
        cached = list;
        return list;
      })
      .catch(() => {
        cached = [];
        return [] as PublicNoticeSummary[];
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** 활성 공지 목록. 없으면 배너·메뉴를 숨길 때 사용. */
export function usePublicNotices(): {
  items: PublicNoticeSummary[];
  loaded: boolean;
  hasNotices: boolean;
} {
  const [items, setItems] = useState<PublicNoticeSummary[]>(cached ?? []);
  const [loaded, setLoaded] = useState(cached !== null);

  useEffect(() => {
    let cancelled = false;
    loadNotices().then((list) => {
      if (cancelled) return;
      setItems(list);
      setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loaded, hasNotices: items.length > 0 };
}
